import { useSelector } from 'react-redux'
import { selectAllTranslations } from '../translations/translationsSlice'

export class Translation
{
    static translations = [];

    static init = () => {
        this.translations = useSelector(selectAllTranslations);
    }

    static t = (originalLabel) => {
        if (originalLabel == null) {
            return null;
        }

        const translation = this.translations.find((x) => x.key == originalLabel);

        if (translation == null || translation == undefined || translation.text == "") {
            return ((originalLabel?.toString() ?? " ").indexOf(" ") != -1) ?
                originalLabel :
                (originalLabel?.toString() ?? "").substring(0, 20) + (originalLabel?.toString().length > 20 ? ".." : "")
        }
        return translation.text
    }
}